import * as React from 'react';

import { autoprefixer } from '../../material-ui/autoprefixer';

import l10n from '../../util/l10n';

interface HexSelectorProps extends React.Props<HexSelector> {
    hexColor: string;
    onChange?: (hexColor: string) => void;
}

interface HexSelectorState {
    hexColor: string;
    isFocused: boolean;
    isInvalid: boolean;
}

export class HexSelector extends React.Component<HexSelectorProps, HexSelectorState> {

    constructor(props: HexSelectorProps) {
        super(props);

        this.state = {
            hexColor: props.hexColor,
            isFocused: false,
            isInvalid: false
        };
    }

    componentWillReceiveProps(nextProps: HexSelectorProps) {
        if (this.props.hexColor !== nextProps.hexColor) {
            this.setState({ hexColor: nextProps.hexColor } as HexSelectorState);
        }
    }

    render() {
        const styles = this.getStyles();

        return (
            <div style={styles.root}>
                <label style={styles.label}>
                    {l10n('colorPicker.label.hex')}
                    <input
                        style={Object.assign({}, styles.input, { /* TODO: Use colors from some theme. */
                            borderColor: this.state.isInvalid
                              ? '#F44336'
                              : this.state.isFocused
                                  ? '#00BCD4'
                                  : '#D9D8D8'
                        })}
                        value={this.state.hexColor}
                        onChange={(event) => this.onChangeHex((event.target as HTMLInputElement).value)}
                        onFocus={this.onFocusHex}
                        onBlur={(event) => this.onBlurHex((event.target as HTMLInputElement).value)}
                        data-test-id="color-picker-input-hex"
                    />
                </label>
            </div>
        );
    }

    private onChangeHex = (value: string) => {
        value = value.toUpperCase();

        while (value.charAt(0) === '#') {
            value = value.substring(1);
        }

        for (let index = 0, { length } = value; index < length; ++index) {
            if ('0123456789ABCDEF'.indexOf(value.charAt(index)) < 0) {
                return;
            }
        }

        this.setState({ hexColor: value } as HexSelectorState);

        // If we have a valid `value`,
        // then provide instant feedback.
        if (value.length === 6) {
            if (this.props.onChange) {
                this.props.onChange(value);
            }

            this.setState({ isInvalid: false } as HexSelectorState);
        } else {
            this.setState({ isInvalid: value.length !== 3 } as HexSelectorState);
        }
    };

    private onFocusHex = () => {
        this.setState({ isFocused: true } as HexSelectorState);
    };

    private onBlurHex = (value: string) => {
        this.setState({ isFocused: false } as HexSelectorState);

        if (value.length === 3) {
            const [ c0, c1, c2 ] = value.split('');

            value = `${c0}${c0}${c1}${c1}${c2}${c2}`;
        }

        if (value.length !== 6) {
            value = this.props.hexColor;
        }

        this.setState({
            hexColor: value,
            isInvalid: false
        } as HexSelectorState);

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    private getStyles() {
        return {
            root: Object.assign(autoprefixer({
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignContent: 'space-between' }), {
                width: '100%'
            }),
            label: Object.assign(autoprefixer({
                flexGrow: 1 }), {
                height: 30,
                lineHeight: '30px',
                textAlign: 'right',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }),
            input: {
                width: 60,
                height: 24,
                fontSize: 13,
                fontFamily: 'Open Sans',
                textAlign: 'center',
                border: '1px solid',
                outline: '0',
                marginLeft: 8,
                marginRight: 4,
                padding: 2
            }
        };
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/HexSelector.tsx
 **/